import { css } from '@emotion/react';

export const layoutContainerStyles = css``;

export const childrenContainerStyles = css`
  border: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const videoContainerStyles = css`
  width: 100%;
`;

export const videoStyles = css`
  width: 100%;
`;
